import { observable } from 'mobx'

/**
 * Author: Hanamantraya R
 * Class Name: ObjSSO
 * Description: Observation Class to create object of class for Widgets.
 */
export default class {
  id = null;
  @observable widget_name = null;
  @observable widget_size = null;
  @observable can_user_hide = null;
  @observable unbox_widget = null;
  @observable is_image_uploaded = null;
  @observable widget_description = null;
  @observable is_custom_image = null;
  @observable widget_logo = null;
  @observable widget_slug_id = null;
  @observable is_deleted = null;
  @observable is_replace_with_crm_widget = null;
  @observable crm_widget_id = null;
  @observable widget_height = null;

  /**
   * @Author: Hanamantraya R
   * @Method: constructor
   * @Param: Object(params)
   * @Return: Void
   * Description: Nothing return
   */
  constructor (json) {
    this.id = json.id
    this.widget_name = json.widget_name
    this.widget_size = json.widget_size
    this.can_user_hide = json.can_user_hide
    this.unbox_widget = json.unbox_widget
    this.is_image_uploaded = json.is_image_uploaded
    this.widget_description = json.widget_description
    this.is_custom_image = json.is_custom_image
    this.widget_logo = json.widget_logo
    this.widget_slug_id = json.widget_slug_id
    this.is_deleted = json.is_deleted
    this.is_replace_with_crm_widget = json.is_replace_with_crm_widget
    this.crm_widget_id = json.crm_widget_id ? json.crm_widget_id : ''
    this.widget_height = json.widget_height ? json.widget_height : '0px'
  }

  /**
   * @Author: Hanamantraya R
   * @Method: jsonToArray
   * @Param: Object(json)
   * @Return: Array
   * Description: Return array of objects
   */
  static jsonToArray (json) {
    return json.reduce((acc, curr) => {
      acc[curr.id] = new this(curr)
      return acc
    }, {})
  }

  /**
   * @Author: Hanamantraya R
   * @Method: constructFromJSON
   * @Param: Object(json)
   * @Return: Object
   * Description: Return  objects
   */
  static constructFromJSON (json) {
    return new this(json)
  }

  /**
   * @Author: Hanamantraya R
   * @Method: constructFromJSON
   * @Param: Object(entries)
   * @Return: Object
   * Description: Update the details of particular record
   */
  update (entries) {
    for (const key in entries) {
      this[key] = entries[key]
    }
  }
}
